import { MediaType } from '../../globals'
import Linkify from '../Linkify'
import IFrameComponent from './IFrameComponent'
import ImageComponent from './ImageComponent'

type MediaData = { url: string; description: string; linkDisplayText: string }

type MediaTypeComponentProps = {
  mediaType?: MediaType
  mediaData: Partial<MediaData>
}

const MediaTypeComponent = ({
  mediaType,
  mediaData: { url, description, linkDisplayText }
}: MediaTypeComponentProps) => {
  switch (mediaType) {
    case MediaType.IMAGE:
      return <ImageComponent url={url} description={description} />
    case MediaType.VIDEO:
      return (
        <video
          className="media-item message-text"
          src={url}
          controls
          aria-label={description}
        />
      )
    case MediaType.AUDIO:
      return (
        <audio
          className="media-item media-item-audio message-text"
          src={url}
          controls
          aria-label={description}
        />
      )
    case MediaType.EMBEDDED_LINK:
    case MediaType.LINK:
      return <IFrameComponent url={url} />
    case MediaType.EMBEDDED_LARGE:
      return <IFrameComponent url={url} style={{width:400, height:650}}/>
    case MediaType.PRETTY_LINK:
      return (
        <div className="message-text">
          <Linkify content={url} linkDisplayText={linkDisplayText} />
        </div>
      )
    default:
      throw new Error(`Unsupported media type of ${mediaType}`)
  }
}

export default MediaTypeComponent
